import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

document.addEventListener('DOMContentLoaded', () => {
    const maps = document.querySelectorAll('.c-map__map');
    if (!maps) return;

    maps.forEach((mapEl) => {
        const lat = parseFloat(mapEl.dataset.lat);
        const lng = parseFloat(mapEl.dataset.lng);

        if (!lat || !lng) return;

        const map = L.map(mapEl, {
            zoomControl: false,     // Oculta los controles si quieres un look más limpio
            dragging: true,        // Desactiva mover el mapa (opcional)
            scrollWheelZoom: false, // Desactiva zoom con scroll
            doubleClickZoom: false,
            boxZoom: false,
            keyboard: false,
            tap: false,
        }).setView([lat, lng], 16);

        // Capa tipo “Apple Maps light”
        L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
            attribution: '',
            maxZoom: 19,
        }).addTo(map);

        // 🔘 Marcador circular negro sin interacción
        L.circleMarker([lat, lng], {
            radius: 8,
            color: '#000',
            fillColor: '#000',
            fillOpacity: 1,
            interactive: false, // <- evita clics o eventos
        }).addTo(map);
    });
});
